var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g({class:[
        _vm.buttonClass,
        _vm.buttonInfoDict.class
    ],attrs:{"outlined":"","color":_vm.buttonInfoDict.color}},_vm.$listeners),[(!_vm.hideIcon)?_c('icon',{attrs:{"value":_vm.buttonInfoDict.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.buttonInfoDict.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }